import { updateSelectionByValue } from '@wix/da-ds/pkg/Dropdown/helpers';

export const updateItemSelection = (items, value, isSelected = true) =>
  items.map(item => ({
    ...item,
    selected: item.value === value ? isSelected : item.selected,
  }));

export const deselectItems = items => items.map(item => ({ ...item, selected: false }));

export const deselectItemsMatching = (items, condition) =>
  items.map(item => (condition(item) ? { ...item, selected: false } : item));

export const selectFirstItem = items =>
  items && items.length > 0 ? [{ ...items[0], selected: true }, ...items.slice(1)] : items;

export const deselectGroup = group => ({
  ...group,
  selected: false,
  items: deselectItems(group.items),
});

export const selectGroupsFirstItem = group => ({
  ...group,
  selected: true,
  items: selectFirstItem(group.items),
});

export const selectGroupItemByValue = (group, value) => ({
  ...group,
  selected: true,
  items: updateSelectionByValue(value, group.items),
});

export const anySelected = (items: any[] = [], condition?: (item) => boolean) =>
  items.some(item => (condition ? (condition(item) && item.selected) || false : item.selected));
